import { Stack } from '@mui/material';
import React from 'react';
import { TextStyled, TitleStyled } from './j-info-box.styled';

interface Props {
  label: string;
  value?: string | null;
  bold?: boolean;
}
const JInfoBox = ({ label, value, bold = false }: Props) => {
  if (!value) return <></>;
  return (
    <Stack gap={0.2}>
      <TitleStyled data-qa={label}>{label}</TitleStyled>
      <TextStyled bold={bold} data-qa={value}>
        {value}
      </TextStyled>
    </Stack>
  );
};

export default JInfoBox;
